"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const constants_1 = require("../../constants/constants");
const styles_1 = __importDefault(require("../../styles/styles"));
const icon_1 = __importDefault(require("../icon/icon"));
const messageComponentStyles_1 = __importDefault(require("./messageComponentStyles"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const MessageComponent = ({ message, color, icon }) => {
    const isDesktop = useWebDesktopDesign_1.default();
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.Platform.OS === constants_1.WEB_TAG ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.centerChilds },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, styles_1.default.alignCenterCenter, messageComponentStyles_1.default.sizeBox] },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                    react_1.default.createElement(icon_1.default, { icon: icon, color: color, size: 140 })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexWrap, !isDesktop && { width: 250 }] },
                    react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, messageComponentStyles_1.default.text] }, message))))));
};
exports.default = MessageComponent;
